<template>

    <!--    <div>-->
    <!--        <label :for="name">{{name}}</label>-->
    <textarea  :id="name" :name="name" v-if="mode === 'textarea'" >{{ values ? values : '' }}</textarea>
    <input :id="name" :name="name" v-else :value="values" >
    <!--    </div>-->
</template>

<script>
import Tagify from "@yaireo/tagify/dist/tagify.min.js";
import "@yaireo/tagify/dist/tagify.css";

//https://github.com/yairEO/tagify#installation
//https://codesandbox.io/s/tagify-tags-component-vue-example-l8ok4?file=/src/App.vue:380-524
//https://yaireo.github.io/tagify/

export default {
    name: "input-autocomplete",
    props: {
        mode: String,
        autocomplete: String,
        'name': {
            type: String,
            required: true
        },
        'max': {
            type: Number,
        },
        'values': {
            type: String,
            required: true
        }
    },
    data() {
        return {}
    },
    mounted() {
        this.tagify = new Tagify(this.$el,
            {
                whitelist: JSON.parse(this.autocomplete),
                dropdown: {
                    classname: "color-blue tagify--hasMaxTags",
                    enabled: true,              // show the dropdown immediately on focus
                    maxTags: this.max,
                    position: "text",         // place the dropdown near the typed text
                    closeOnSelect: false,          // keep the dropdown open after selecting a suggestion
                    highlightFirst: true
                },
                originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(',')

            });
        // this.tagify.addTags(JSON.parse(this.values) )
    }
}
</script>

<style>
ul.flex {
    flex: unset !important;
}

li.flex {
    flex: unset !important;
}

.child-flex > *, .flex {
    flex: unset !important;
}

li.mt-1.ml-1.mb-0.flex.justify-between.content-center {
    flex: unset;
    flex-grow: unset;
    flex-shrink: unset;
    flex-basis: unset;
}
</style>
